import MuiSvgIcon, { SvgIconProps as MuiSvgIconProps } from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";
import React, { forwardRef, FunctionComponent } from "react";

const PREFIX = "SvgIcon";

const classes = {
	fillCurrentColor: `${PREFIX}fillCurrentColor`,
};

const StyledSvgIcon = styled(MuiSvgIcon)(({
	theme,
}) => ({
	[`&.${classes.fillCurrentColor}`]: {
		"& > *": {
			fill: "currentColor",
		},
	},
}));

export interface SvgIconProps extends MuiSvgIconProps {
    /** indicates if the icon should have the current color as its fill */
    fillCurrentColor?: boolean;
}

const SvgIcon: FunctionComponent<SvgIconProps> = forwardRef((props, ref) => {
	const { fillCurrentColor, className, ...otherProps } = props;
	return (
		<StyledSvgIcon
			className={`${fillCurrentColor ? classes.fillCurrentColor : ""} ${className || ""}`}
			{...{ ref }}
			{...otherProps}
		/>
	);
});

export default SvgIcon;